// Central site configuration & shared assets

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_cc-strategic-sprint/artifacts/6liwfwmu_Logo_Icon%20Large.png";

export const CALENDLY_URL = "https://calendly.com/megan-culturalcapital";
export const CONTACT_EMAIL = "info@culturalcapital.ca";
export const LOCATION = "Toronto, ON";
export const COMPANY_LEGAL = "Cultural Capital Analytics Inc.";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const IMAGES = {
  heroArch:
    "https://images.unsplash.com/photo-1563441082154-be8c9b37f115?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8Ymx1ZXwxNzgxNjM4NzEzfDA&ixlib=rb-4.1.0&q=85",
  archAlt:
    "https://images.unsplash.com/photo-1493397212122-2b85dda8106b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8Ymx1ZXwxNzgxNjM4NzEzfDA&ixlib=rb-4.1.0&q=85",
  geo1:
    "https://images.unsplash.com/photo-1560763150-5f34e9c1e68d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxnZW9tZXRyaWMlMjBzdHJ1Y3R1cmV8ZW58MHx8fGJsdWV8MTc4MTYzODcxM3ww&ixlib=rb-4.1.0&q=85",
  geo2:
    "https://images.unsplash.com/photo-1600540984005-c7f3a641fbe5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxnZW9tZXRyaWMlMjBzdHJ1Y3R1cmV8ZW58MHx8fGJsdWV8MTc4MTYzODcxM3ww&ixlib=rb-4.1.0&q=85",
  building1:
    "https://images.unsplash.com/photo-1560179707-f14e90ef3623?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBidWlsZGluZ3xlbnwwfHx8Ymx1ZXwxNzgxNjM4NzEzfDA&ixlib=rb-4.1.0&q=85",
  building2:
    "https://images.unsplash.com/photo-1554469384-e58fac16e23a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBidWlsZGluZ3xlbnwwfHx8Ymx1ZXwxNzgxNjM4NzEzfDA&ixlib=rb-4.1.0&q=85",
};
